// removed by extract-text-webpack-plugin
module.exports = {"loadingBar":"loadingBar__1WgQB","shimmer":"shimmer__3B49L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingTable/styles.scss
// module id = 2134
// module chunks = 1